module.exports = __webpack_public_path__ + "img/pixel.d71c908a.png";